import React from 'react'
import { changeFormatdateSlip } from '../../../../utils/formatdate'
import { Typography, Tabs, Row, Col, Form, Input, Switch, DatePicker, Pagination, Icon, Button, Modal, Checkbox, Select } from 'antd'
import { UrlMeeting } from '../../../../utils/auth'
import { withApollo } from 'react-apollo'
import Container from '../../../../components/user/Container'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../../components/user/ModalErrors'
import axios from 'axios';
import moment from 'moment/min/moment-with-locales';
import axiosAPI from '../../../../config/axiosAPI'

const { Option } = Select;
const { Search } = Input;

class CreatePDFMeeting extends React.Component {

    state = {
        idMeeting: null,
        dataMeeting: [],
        organizer: {},
        approver: {},
    }


    componentDidMount = async () => {
        this.fetchDataMeeting();
    }
    fetchDataMeeting = async () => {
        const queryString = require('query-string');
        const parsed = queryString.parse(this.props.location.search);
        if (parsed.id) await this.setState({ idMeeting: parsed.id })
        axiosAPI.post(`${UrlMeeting()}/meeting/secure/meetingdetail`,
            {
                MeetingID: parsed.id
            })
            .then(response => {
                const data = response.data.status.message
                this.setState({
                    dataMeeting: data[0] ? data[0] : [],
                    organizer: data[1]?.OrganizerDetail ? data[1].OrganizerDetail : {},
                    approver: data[1]?.ApproverDetail ? data[1].ApproverDetail : {},
                })
                console.log("data", data);
            }).catch(
                error => console.error(`Error: ${error}`)
            )
    }

    handleSubmit = async () => {
        
        const { form, afterSubmit, client } = this.props
        form.validateFields(async (err, values) => {

            const dataParam =
            {
                docmentDate: values.docmentDate,
                subject: values.subject,
                documentNumber: values.documentNumber ,
                location: values.location ,
                details: values.details ,
                endDetails: values.endDetails ,
                meetingDate: values.meetingDate ,
                OrganizerDetail:  {
                    organizationName: values.organizationName ,
                    divisionName: values.divisionName ,
                    fullName: values.OrganizerDetailfullName ,
                    tel: values.OrganizerDetailtel ,
                },
                ApproverDetail:  {
                    fullName: values.ApproverDetailfullName ,
                    role: values.ApproverDetailrole ,
                }
            }
            console.log("dataParam", dataParam);

            axiosAPI.post(`${UrlMeeting()}/meeting/secure/createpdfinvitemeeting`,
                {
                    ...dataParam
                })
                .then(response => {
                    let data = response.data.status.message.imageSrc
                    window.open(`${UrlMeeting()}/meeting/file/${data}`, '_blank');
                    console.log("response", data);
                }).catch(
                    error => console.error(`Error: ${error}`)
                )
        })

    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { match } = this.props
        const { dataMeeting, organizer, approver } = this.state
        
        const concatName = (organizer?.title || "") + " " + (organizer?.firstName || "") + " " + (organizer?.lastName || "");
        const fullName = concatName.trim() === "" ? "" : concatName
        
        const concatApproveName = (approver?.title || "") + " " + (approver?.firstName || "") + " " + (approver?.lastName || "");
        const fullApproveName = concatApproveName.trim() === "" ? "" : concatApproveName
        
        const meetingDateTime = !(dataMeeting?.startDate && dataMeeting?.endDate) ? "" :
                                moment(dataMeeting?.startDate).locale('th').add(543,'year').format('DD MMMM yyyy') 
                                + " เวลา " 
                                + moment(dataMeeting?.startDate).format('HH:mm')
                                + " - "
                                + moment(dataMeeting?.endDate).format('HH:mm น.')
        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalConfirmErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <div className="card-container meeting-management" id="form-meeting">
                    <div className="card-bg-white">
                        <Row className="pt-4 pb-3 px-3" gutter={16} type="flex">
                            <Col xs={19} >
                                <a href="javascript:history.back()">
                                    <Icon type="left" className="icon-back-meeting" /><p style={{ display: "inline", color: "#4D4D4D" }}> สร้างหนังสือเชิญประชุม</p>
                                </a>
                            </Col>
                        </Row>
                        <Form onSubmit={this.handleSubmit}>
                            <Row className="px-5 py-3" gutter={16} type="flex" justify="center" align="top">

                                <Col xs={24} md={12}>
                                    <Form.Item label={"วันที่ออกเอกสาร"} name={"docmentDate"} className="mb-0">
                                        {getFieldDecorator("docmentDate", {
                                            initialValue: dataMeeting.documentDate ? moment(dataMeeting.documentDate).locale('th').add(543,'year').format("DD MMMM yyyy") : "",
                                            rules: [{
                                                required: false,
                                                message: 'กรุณาระบุ วันที่ออกเอกสาร',
                                            }],
                                        })(
                                            <Input
                                                disabled={dataMeeting.documentDate}
                                                placeholder='กรอกวันที่ออกเอกสาร'
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Form.Item label={"หัวข้อการประชุม"} name={"subject"} className="mb-0">
                                        {getFieldDecorator("subject", {
                                            initialValue: dataMeeting.subject,
                                            rules: [{
                                                required: false,
                                                message: 'กรุณาระบุ หัวข้อการประชุม',
                                            }],
                                        })(
                                            <Input
                                                disabled={dataMeeting.subject}
                                                placeholder='กรอกหัวข้อการประชุม'
                                            />
                                        )}
                                    </Form.Item>
                                </Col>

                                <Col xs={24} md={12}>
                                    <Form.Item label={"เลขที่เอกสาร"} name={"documentNumber"} className="mb-0">
                                        {getFieldDecorator("documentNumber", {
                                            initialValue: "",
                                            rules: [{
                                                required: false,
                                                message: 'กรุณาระบุ เลขที่เอกสาร',
                                            }],
                                        })(
                                            <Input
                                                placeholder='กรอกเลขที่เอกสาร'
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Form.Item label={"สถานที่"} name={"location"} className="mb-0">
                                        {getFieldDecorator("location", {
                                            initialValue: dataMeeting.location,
                                            rules: [{
                                                required: false,
                                                message: 'กรุณาระบุ สถานที่',
                                            }],
                                        })(
                                            <Input
                                                disabled={dataMeeting.location}
                                                placeholder='กรอกสถานที่'
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Form.Item label={"รายละเอียด"} name={"details"} className="mb-0">
                                        {getFieldDecorator("details", {
                                            initialValue: "",
                                            rules: [{
                                                required: false,
                                                message: 'กรุณาระบุ รายละเอียด',
                                            }],
                                        })(
                                            <Input
                                                placeholder='กรอกรายละเอียด'
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Form.Item label={"รายละเอียดเพิ่มเติม"} name={"endDetails"} className="mb-0">
                                        {getFieldDecorator("endDetails", {
                                            initialValue: dataMeeting.endDetails,
                                            rules: [{
                                                required: false,
                                                message: 'กรุณาระบุ รายละเอียดเพิ่มเติม',
                                            }],
                                        })(
                                            <Input
                                                placeholder='กรอกรายละเอียดเพิ่มเติม'
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Form.Item label={"วันที่"} name={"meetingDate"} className="mb-0">
                                        {getFieldDecorator("meetingDate", {
                                            initialValue: meetingDateTime,
                                            rules: [{
                                                required: false,
                                                message: 'กรุณาระบุ วันที่',
                                            }],
                                        })(
                                            <Input
                                                disabled={meetingDateTime}
                                                placeholder='กรอกวันที่'
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Form.Item label={"ชื่อสำนัก"} name={"organizationName"} className="mb-0">
                                        {getFieldDecorator("organizationName", {
                                            initialValue: organizer.organizationName,
                                            rules: [{
                                                required: false,
                                                message: 'กรุณาระบุ ชื่อสำนัก',
                                            }],
                                        })(
                                            <Input
                                                disabled={organizer.organizationName}
                                                placeholder='กรอกชื่อสำนัก'
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Form.Item label={"ชื่อฝ่าย"} name={"divisionName"} className="mb-0">
                                        {getFieldDecorator("divisionName", {
                                            initialValue: organizer.divisionName,
                                            rules: [{
                                                required: false,
                                                message: 'กรุณาระบุ ชื่อฝ่าย',
                                            }],
                                        })(
                                            <Input
                                                disabled={organizer.divisionName}
                                                placeholder='กรอกชื่อฝ่าย'
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Form.Item label={"ชื่อผู้สร้างประชุม"} name={"OrganizerDetailfullName"} className="mb-0">
                                        {getFieldDecorator("OrganizerDetailfullName", {
                                            initialValue: fullName || "",
                                            rules: [{
                                                required: false,
                                                message: 'กรุณาระบุ ชื่อผู้สร้างประชุม',
                                            }],
                                        })(
                                            <Input
                                                disabled={fullName}
                                                placeholder='กรอกชื่อผู้สร้างประชุม'
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Form.Item label={"เบอร์โทร"} name={"OrganizerDetailtel"} className="mb-0">
                                        {getFieldDecorator("OrganizerDetailtel", {
                                            initialValue: "",
                                            rules: [{
                                                required: false,
                                                message: 'กรุณาระบุ เบอร์โทร',
                                            }],
                                        })(
                                            <Input
                                                placeholder='กรอกเบอร์โทร'
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Form.Item label={"ชื่อผู้อนุมัติ"} name={"ApproverDetailfullName"} className="mb-0">
                                        {getFieldDecorator("ApproverDetailfullName", {
                                            initialValue: fullApproveName,
                                            rules: [{
                                                required: false,
                                                message: 'กรุณาระบุ ชื่อผู้อนุมัติ',
                                            }],
                                        })(
                                            <Input
                                                disabled={fullApproveName}
                                                placeholder='กรอกชื่อผู้อนุมัติ'
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                    <Form.Item label={"ตำแหน่งผู้อนุมัติ"} name={"ApproverDetailrole"} className="mb-0">
                                        {getFieldDecorator("ApproverDetailrole", {
                                            initialValue: dataMeeting.ApproverDetailrole,
                                            rules: [{
                                                required: false,
                                                message: 'กรุณาระบุ ตำแหน่งผู้อนุมัติ',
                                            }],
                                        })(
                                            <Input
                                                placeholder='กรอกตำแหน่งผู้อนุมัติ'
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col xs={24} md={12}>
                                </Col>
                            </Row>
                            <Row type='flex' justify='end' className="px-5 py-3" gutter={16} align="top">
                                {/* <Col xs={24} md={7}>
                                    
                                </Col> */}
                                <Col xs={24} md={24} style={{display:"flex", justifyContent:"end", flexWrap:'wrap'}}>
                                    <Button 
                                    className={'button-meeting-transparent'} 
                                    style={{width:'70px',margin:'5px'}}
                                    onClick={this.props.history.goBack}>
                                        ยกเลิก
                                        </Button>
                                    <Button type="submit" onClick={this.handleSubmit} className={'button-meeting'} style={{width:'230px',margin:'5px'}} >
                                        ยืนยันการสร้างหนังสือเชิญประชุม</Button>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </div >
            </Container >
        )
    }
}

CreatePDFMeeting.propTypes = {
    //
}

// export default withApollo(CreatePDFMeeting)

CreatePDFMeeting.defaultProps = {
    autoFocus: false
}

CreatePDFMeeting.propTypes = {
}

const WrappedSearchForm = Form.create()(CreatePDFMeeting)

export default withApollo(WrappedSearchForm)